import { Component } from '@angular/core';

@Component({
    selector: 'app-captive-form-wrapper',
    templateUrl: './captive-form-wrapper.component.html',
    styleUrls: ['./captive-form-wrapper.component.scss'],
    standalone: false
})
export class CaptiveFormWrapperComponent {}
